import { combineReducers } from "redux";
import { CartReducer, FavouriteReducer, SelectedProductReducer, filterReducer, gridReducer, sortMethodReducer, userReducer } from "./product";


const reducers = combineReducers({
    cart: CartReducer,
    selectedProduct: SelectedProductReducer,
    favourite : FavouriteReducer,
    user: userReducer,
    isGrid: gridReducer,
    filterArray: filterReducer,
    sortingMethod:sortMethodReducer,
});

export default reducers;